import { Outlet } from 'react-router-dom';

import { Container } from '@mui/material';

import AgencyProfileProgressInfo from './layout-components/layout-header/AgencyProfileProgressInfo';
import LayoutHeader from './layout-components/layout-header/LayoutHeader';
import LayoutTabs from './layout-components/layout-tabs/LayoutTabs';

export default function AgencyProfileLayout() {
  return (
    <Container maxWidth="lg">
      <LayoutHeader />
      <AgencyProfileProgressInfo />
      <LayoutTabs />
      <Outlet />
    </Container>
  );
}
